import { render, staticRenderFns } from "./MyCompanyArticlesEdit.vue?vue&type=template&id=27fadad8&scoped=true&"
import script from "./MyCompanyArticlesEdit.vue?vue&type=script&lang=js&"
export * from "./MyCompanyArticlesEdit.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyArticlesEdit.vue?vue&type=style&index=0&id=27fadad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fadad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VRow,VSimpleTable})
